/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { PullColumn } from '@touchplan/common';
import { AbstractCanvasConnection } from './AbstractCanvasConnection';

/**
 * Interface representing the input data into the PullSpaceService
 * This object should be created in an Observable and should include the
 * pull columns object on the plan, along with the pull column fields
 */
export interface IFbdbPullSpace {
	columns: PullColumn[];
	pullFinishX: number;
	pullTicketHeightPixels: number;
	pullTicketWidthPixels: number;
}

@Injectable({ providedIn: 'root' })
export class PullSpaceService extends AbstractCanvasConnection<IFbdbPullSpace> {
	/**
	 * Registers the service to receive pull column data from an Observable source.
	 * @param sourceObs$ Observable stream of pull columns
	 */
	public registerPlanData(sourceObs$: Observable<IFbdbPullSpace>): void {
		super.registerPlanData();

		this._subscription = sourceObs$
			.pipe(filter((data: IFbdbPullSpace) => !!data))
			.subscribe((data: IFbdbPullSpace) => this._changed$.next(data));
	}
}
